import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=8b65b44c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=8b65b44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b65b44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b65b44c')) {
      api.createRecord('8b65b44c', component.options)
    } else {
      api.reload('8b65b44c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=8b65b44c&scoped=true&", function () {
      api.rerender('8b65b44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hFT108M4dzlD/JS/comp/PopupBox.vue"
export default component.exports